import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { GenerateAffinityResult } from "../../recommendation.types";
import { requestGenerateAffinity } from "./generateAffinity.request";

const useGenerateAffinity = (
  options?: MutationOptions<
    GenerateAffinityResult,
    ApiServiceError<ApiError>,
    void
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestGenerateAffinity,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["recommendation", "affinity"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useGenerateAffinity;
